import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-098a665a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  id: "list-example",
  class: "list-group flex-row row mb-4 p-0 m-0"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-right me-2" }, null, -1))
const _hoisted_6 = {
  "data-bs-spy": "scroll",
  "data-bs-target": "#list-example",
  class: "scrollspy-example container bg-white shadow rounded-4 p-lg-4 p-3",
  tabindex: "0"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "fs-6 fw-bold text-center mb- pb-2" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "big-text text-white big-text--dark-green rounded-circle d-flex justify-content-center align-items-center" }, " Q ", -1))
const _hoisted_11 = { class: "mb-0 fs-7 fw-bold" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "big-text text-white big-text--light-green rounded-circle d-flex justify-content-center align-items-center" }, " A ", -1))
const _hoisted_14 = { class: "fs-7" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col-lg-10 bg-gray d-flex flex-column justify-content-center align-items-center px-4 py-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-6 text-center mb-5 fw-bold" }, "その他ご不明な点等は、下記までお問い合わせくださいますようお願いいたします。", -1))

import categories from './data.json'
import Title from '@/components/title/index.vue'
import Button from '@/components/button/index.vue'
import { INQUIRY_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const resetForm = () => {
  store.dispatch(INQUIRY_STORE.ACTIONS.SET_INQUIRY_DATA, { inquiry_type: '1', content: '', file1: '', file2: '', file3: '', email: '' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Title, {
      title: 'よくある質問',
      class: "pt-3"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: category?.categoryName,
            class: "list-group-item bg-gray border-0 col-md-3 col-sm-4 col-6 text-decoration-underline fs-7",
            href: `#list-item-${index}`
          }, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(category?.categoryName), 1)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category, index) => {
        return (_openBlock(), _createElementBlock("div", {
          id: `list-item-${index}`,
          key: index
        }, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(category?.categoryName), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category?.qa, (qa) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-5",
              key: qa.qaId
            }, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("h5", _hoisted_11, _toDisplayString(qa?.question), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(qa?.answer), 1)
              ])
            ]))
          }), 128))
        ], 8, _hoisted_7))
      }), 128)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(Button, {
            title: 'お問い合わせ',
            dataBsToggle: 'modal',
            className: 'fw-bold',
            dataBsTarget: '#inquiryFormModal',
            type: 'secondary',
            onClick: resetForm
          })
        ])
      ])
    ])
  ]))
}
}

})